module.exports = __webpack_public_path__ + "static/googleplay-277d976a317bb33a474b21ce8f3b3166.png";